export enum QUERY_KEYS {
  createAddonPreset = 'create-addon-preset',
  createBulkEventAddons = 'create-event-bulk-addons',
  createEventAddon = 'create-event-addon',
  deleteAddon = 'delete-addons',
  deleteAddonOffer = 'delete-addon-offer',
  deleteAddonPreset = 'delete-addon-preset',
  editAddon = 'edit-event-addon',
  editAddonPreset = 'edit-addon-preset',
  getAddons = 'get-event-addons',
  getAddonsPresets = 'addons-by-company-club',
  getOfferAddons = 'get-offer-addons',
  reorderAddonPresetImages = 'reorder-addon-preset-images',
  setAddonGallery = 'set-addon-gallery',
  reorderAddonImages = 'reorder-addon-images',
  setAddonPresetGallery = 'set-addon-preset-gallery',
}
